module.exports = __webpack_public_path__ + "static/media/fast.5b185c0f.svg";